const styles = (theme) => ({
  text: {
    color: theme.color.grey_dark,
    textDecoration: 'line-through',
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
});

export default styles;
